/* eslint-disable eqeqeq */
import React, { FC, useCallback, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { InputArrayData, InputSelect, InputNumber, InputTextArea } from "../../../../components/input";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { ITToolRequestService } from "../../../../services/it-tools-request/itToolRequest.service";
import { MailService } from "../../../../services/mail/mail.service";
import { codeProcessRequestTypes } from "../code-process/codeRequestType";
import { UserSelect } from "../../../../components/input/select/UserSelect";

import { Col, Row } from "react-bootstrap";

import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";
import { DemandForSuppliesContentForm, DemandForSuppliesContentStructure } from "./demandForSuppliesForm";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import {
  department,
  unitNB,
  unitTSN,
  unitDN,
  hq1Team,
  hq2Team,
  hq3Team,
  psc1Team,
  psc2Team,
  psc3Team,
  pvhk1Team,
  pvhk2Team,
  pvhk3Team,
} from "../data";
import { validatePhoneNumber, validateRequests } from "../../../../services/util";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../helper/dateTimeHelper";
import { Upload } from "../../upload";
import { useQueryClient } from "@tanstack/react-query";
import { eApproveTitleCode } from "../../../../constants/bizTitle";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REQUEST_URL");

export const renewDemandForSuppliesPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState("");
  const [requestType, setRequestType] = useState(codeProcessRequestTypes[0].value);
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [selectedTeam, setSelectedTeam] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);
  const [team, setTeam] = useState<any>([]);
  const [pickedUserName, setPickedUserName] = useState(null as any);
  const queryClient = useQueryClient();

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "phoneNumber",
        label: "SĐT liên hệ",
      },
      {
        name: "description",
        label: "Mô tả",
      },
      {
        name: "pickApprover",
        label: "Người duyệt",
      },
      {
        name: "deparment",
        label: "Cơ quan/ Đơn vị",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "union",
        label: "Đội/Tổ",
      },
      {
        name: "findApprover",
        label: "Người duyệt thay thế",
      },
      {
        name: "tooltechnology",
        label: "Công cụ công nghệ thông tin",
      },
      {
        name: "requests",
        label: "Nội dung chi tiết",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
      {
        name: "department",
        label: "Đơn vị sử dụng",
      },
    ],
    onSubmit: async (payload) => {
      const { description, phoneNumber, requests, fileRequests } = payload;

      if (!phoneNumber) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng nhập SĐT liên hệ!", icon: "/icons/warning.png" });
        return;
      }

      const formattedValue = phoneNumber.toString().padStart(10, "0");

      if (!validatePhoneNumber(formattedValue)) {
        CreateNotification({ title: "Thông báo", body: "Số điện thoại không hợp lệ!", icon: "/icons/warning.png" });
        return;
      }

      if (requests.length == 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (requests.length) {
        const isValidateAllRequests = validateRequests(requests);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Nội dung chi tiết chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (!approver) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }
      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const software: any = softwares.find((f: any) => f.eSystemCode === "ITT");
      const assignees = software.eITStaff.split(";");

      const commonFields = {
        eDescription: description,
        eContent: JSON.stringify(requests),
        eFileContent: JSON.stringify(fileRequests),
        ePhoneNumber: formattedValue,
      };

      const ITToolRequests: any = {
        fields: {
          ...commonFields,
        },
      };

      const addRequestFields = {
        fields: {
          ...ITToolRequests.fields,
          Title: "Nhu cấp vật tư CNTT",
          eApprovedBy: approverTmp ? `${approverTmp.eMail}|${approverTmp.Title}` : `${approver}|${pickedUserName}`,
          eSoftwareId: software.id,
          eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
          eAssignee: `${assignees[0]}`,
          eRequestStatus: requestStatus.submitted,
          eRequestType: requestType,
          eDepartment: selectedDepartment.value,
          eUnit: selectedUnit.value,
          eUnion: selectedTeam.value,
          ePhoneNumber: formattedValue,
        },
      };
      addITToolRequest(addRequestFields);
    },
  });

  const sendMail = async (approver: any, itToolRequest: any) => {
    const url = siteUrl + "/details/" + itToolRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ITTRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", itToolRequest.createdBy.user.displayName)
      .replace(mailRegexs.nine + ";", itToolRequest.id)
      .replace(mailRegexs.ten + ";", itToolRequest.fields.eDescription ?? "")
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(itToolRequest.createdDateTime)} - ${getHHmmFormat(itToolRequest.createdDateTime)}`,
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const addITToolRequest = (itToolRequest: any) => {
    ITToolRequestService.addITToolRequest(itToolRequest).then(
      (res) => {
        CreateNotification({
          title: "Thành công",
          body: `Tạo yêu cầu thành công.`,
          icon: "/icons/success.png",
        });
        if (itToolRequest.fields.eApprovedBy) {
          sendMail(itToolRequest.fields.eApprovedBy, res);
        }
        queryClient.invalidateQueries({ queryKey: ["demand-for-supplies-requests"] });
        history.push(Routes.demandForSuppliesDetailPage.path.replace(":id", res.id));
      },
      (error) => {
        CreateNotification({
          title: "Thất bại",
          body: `Tạo yêu cầu thất bại.`,
          icon: "/icons/error.png",
        });
        console.log(error);
      },
    );
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
    setPickedUserName(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].displayName.toLowerCase()
        : null,
    );
  };

  const getApproverOptions = useCallback(() => {
    let approvers: any = [];
    if (selectedDepartment && selectedDepartment.id > 0 && selectedUnit)
      approvers = employees
        .filter((f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedUnit.id)
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
    else if (selectedDepartment && selectedDepartment.id !== 0)
      approvers = employees
        .filter(
          (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedDepartment.id,
        )
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
    setApproverOptions(approvers);
    // const defaultApprover = approvers.find((a: any) => a.default);
    // setApprover(defaultApprover.value || approvers[0].value);
  }, [employees, selectedDepartment, selectedUnit]);

  const onDepartmentChange = (selectedOptions: any) => {
    setApprover("");
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    setSelectedTeam(null);
    setTeam([]);
    if (selectedOptions && typeof selectedOptions.id === "string") {
      setSelectedUnit(selectedOptions);
      setSelectedTeam(selectedOptions);
    }
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
    setSelectedTeam(null);
  };

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedUnit && selectedUnit.id) {
      if (selectedDepartment.id === 1 || selectedDepartment.id === 2 || selectedDepartment.id === 3) {
        const id = +selectedUnit?.id?.slice(-1);
        const key = selectedUnit?.id?.slice(0, -1);
        if (key === "HQ") setTeam(id === 1 ? hq1Team : id === 2 ? hq2Team : id === 3 ? hq3Team : []);
        else if (key === "PSC") setTeam(id === 1 ? psc1Team : id === 2 ? psc2Team : id === 3 ? psc3Team : []);
        else if (key === "PVHK") setTeam(id === 1 ? pvhk1Team : id === 2 ? pvhk2Team : id === 3 ? pvhk3Team : []);
        else if (key === "GA") setTeam([{ id: "GA", value: "Bộ phận hành chính tổng hợp" }]);
        else if (key === "PVHH") setTeam([{ id: "PVHH", value: "Đội phục vụ hàng hóa" }]);
        else {
          setTeam([{ id: selectedUnit.id, value: selectedUnit.value }]);
          setSelectedTeam(selectedUnit);
        }
      } else {
        setTeam([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedTeam(selectedDepartment);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnit]);

  useEffect(() => {
    if (id != 0) {
      ITToolRequestService.getITToolRequest(id)
        .then((res) => {
          const { eDescription, eRequestType, eContent, eFileContent, ePhoneNumber } = res.fields;
          setValues({
            description: eDescription,
            requests: JSON.parse(eContent),
            fileRequests: JSON.parse(eFileContent),
            phoneNumber: ePhoneNumber,
          });
          setRequestType(eRequestType);
          // setApprover(approverEmail);
          // setSelectedDepartment(eDepartment);
          // setSelectedUnit(eUnit);
        })
        .catch((error) => console.log(error));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    getApproverOptions();
  }, [getApproverOptions]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureDemandForSupplies.path)}>
              <Icon.ArrowLeft />
            </div>
            {"Tạo Yêu Cầu Cấp CCDC CNTT"}
          </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            {/* { id == 0 && */}
            {true && (
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("deparment")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={department.map((o: any) => ({
                          id: o.id,
                          label: o.value,
                          value: o.value,
                        }))}
                        value={selectedDepartment}
                        onChange={onDepartmentChange}
                        placeholder="* Chọn Cơ quan/ đơn vị"
                      />
                    )}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("unit")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={unit.map((o: any) => ({
                          id: o.id,
                          label: o.value,
                          value: o.value,
                        }))}
                        value={selectedUnit?.value}
                        isMutilLocale={true}
                        onChange={onUnitChange}
                        placeholder={"* Chọn đơn vị"}
                      />
                    )}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col sm="6" md="6">
                <InputWraper
                  inputProps={getInputProps("union")}
                  renderInput={(s) => (
                    <InputSelect
                      {...s}
                      options={team.map((o: any) => ({
                        id: o.id,
                        label: o.value,
                        value: o.value,
                      }))}
                      value={selectedTeam?.value}
                      onChange={onTeamChange}
                      placeholder="* Chọn đội/tổ"
                    />
                  )}
                />
              </Col>
              <Col sm="6" md="6">
                <InputWraper
                  inputProps={getInputProps("phoneNumber")}
                  renderInput={(s) => <InputNumber {...s} />}
                  isRequired
                />
              </Col>
            </Row>
            <InputWraper inputProps={getInputProps("description")} component={InputTextArea} />

            <InputWraper
              inputProps={getInputProps("requests")}
              renderInput={(state) => (
                <InputArrayData
                  {...state}
                  form={DemandForSuppliesContentForm}
                  structure={DemandForSuppliesContentStructure}
                  excelTemplate="demand-for-supply"
                />
              )}
            />

            <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

            {/* {id == 0 && ( */}
            {true && (
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("pickApprover")}
                    renderInput={(s) => (
                      <UserSelect
                        {...s}
                        placeholder="Thủ trưởng CQ/ĐV"
                        options={approverOptions}
                        value={approver}
                        onChange={onApproverChange}
                      />
                    )}
                    isRequired={id === "0"}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("findApprover")}
                    renderInput={(s) => (
                      <div className="people_picker-custom">
                        <PeoplePicker
                          className="people-picker"
                          placeholder="Thủ trưởng CQ/ĐV"
                          type={PersonType.any}
                          selectionChanged={onApproverPickerChange}
                        />
                      </div>
                    )}
                  />
                </Col>
              </Row>
            )}
            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="danger-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureDemandForSupplies.path)}
              />
            </div>
          </form>
        </Box>
      </div>
    </div>
  );
});
